import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {addPrefix} from "../../../utils/UriUtil";
import {jsonResponseHandler, revenueResponseHandler} from "../../../utils/FetchHelper";
import classnames from "classnames";
import {number_format} from "../../../utils/formatter";
import dateFormat from "dateformat";

const RevenueSummary = ({vendor}) => {
  const dispatch = useDispatch();
  const revenue = useSelector(state => state.revenue);

  const scopes = [
    {
      keyword: 'lastDay',
      label: '최근 1일',
    },
    {
      keyword: 'last7Days',
      label: '최근 7일',
    },
    {
      keyword: 'last30Days',
      label: '최근 30일',
    }
  ];
  const [summary, setSummary] = useState(null);
  const [cacheTime, setCacheTime] = useState(null);
  const [error, setError] = useState(false);
  const fetchRevenueSummary = () => {
    setError(false);
    fetch(addPrefix(`/manage/revenue/summary/${vendor}.json`), {
      credentials: "include",
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(jsonResponseHandler(dispatch))
      .then(revenueResponseHandler(dispatch))
      .then(r => r.json())
      .then(data => {
        if (data) {
          setCacheTime(data.cacheTime);
          setSummary(data.data);
        }
      })
      .catch(e => {
        console.error(e);
        setError(true);
      });
  };
  useEffect(() => {
    fetchRevenueSummary();
  }, []);
  return (
    <>
    <h4 className="tit_cont">수익<span className="txt_date">{dateFormat(cacheTime, 'yyyy-mm-dd HH:MM')} 기준</span></h4>
    <div className="wrap_box wrap_box_type2">
      {!error &&
      <div className="box_blog box_revenue_state">
        {
          scopes.map((scope) => {
            return (
              <dl className="count_revenue" key={scope.keyword}>
                <dt className="tit_revenue">{scope.label} 수익</dt>
                {summary &&
                <dd className="revenue_cont">
                  <div className="revenue_val">
                    <span className="num_g">{number_format(summary[scope.keyword].value)}</span>
                    {vendor === 'adfit' &&
                    <span className="txt_g">원</span>
                    }
                    {vendor === 'adsense' &&
                    <span className="txt_g">USD</span>
                    }
                  </div>
                  <div className="revenue_chg">
                                    <span
                                      className={classnames('num_g', summary[scope.keyword].variation >= 0 ? 'num_up' : 'num_down')}>
                                        {number_format(Math.abs(summary[scope.keyword].variation))}
                                    </span>
                    <span
                      className={classnames('ico_blog', summary[scope.keyword].variation >= 0 ? 'ico_up' : 'ico_down')}>
                                        {summary[scope.keyword].variation >= 0 ? '상승' : '하락'}
                                    </span>
                  </div>
                </dd>
                }
                {!summary &&
                <dd className="revenue_cont">
                  <div className="date_loading">
                    <div className="inner_g">
                      <span className="ico_blog ico_loading">로딩중입니다.</span>
                    </div>
                  </div>
                </dd>
                }
              </dl>
            )
          })
        }
      </div>
      }
      {error &&
      <div className="box_blog box_revenue_state">
        <div className="statistic_refresh info_none">
          <div className="inner_refresh">
            <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
            <a onClick={fetchRevenueSummary} className="link_none">다시 조회하기</a>
          </div>
        </div>
      </div>
      }
      <div className="box_blog">
        <dl className="count_revenue">
          <dt className="tit_revenue">잔고</dt>
          {!error &&
          <dd className="revenue_cont">
            {summary &&
            <div className="revenue_val">
              <span className="num_g">{number_format(summary.totalEarnings)}</span>
              {vendor === 'adfit' &&
              <span className="txt_g">원</span>
              }
              {vendor === 'adsense' &&
              <span className="txt_g">USD</span>
              }
            </div>
            }
            {!summary &&
            <div className="date_loading">
              <div className="inner_g">
                <span className="ico_blog ico_loading">로딩중입니다.</span>
              </div>
            </div>
            }
            <div className="revenue_chg">
              <a className="link_g" onClick={() => window.open(revenue[`${vendor}Info`].paymentUrl)}>정산하기<span
                className="ico_blog ico_arrow_type1"/></a>
            </div>
          </dd>
          }
        </dl>
        {vendor === 'adfit' &&
        <span className="ico_blog ico_money_won02"/>
        }
        {vendor === 'adsense' &&
        <span className="ico_blog ico_money_dollar"/>
        }
      </div>
    </div>
    </>
  )
};

export default RevenueSummary;